import styled from 'styled-components';
import { PositiveFill } from 'ui/icons/status/PositiveFill';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { colors, spacing } from 'ui/theme';
import { Body2, Body2Bold } from 'ui/theme/typography';
import { localizeDateTime, DateFormat, TimeFormat } from 'utils/l10n';
import { Member } from '../../types';
import { useOrganizationMembersQueryContext } from '../../contexts/OrganizationMembersQueryContext';

const Wrapper = styled.div`
  background: ${colors.backgroundSecondary};
  border-radius: ${spacing.half};
  padding: ${spacing.plusHalf};
  display: grid;
  row-gap: ${spacing.plusHalf};
`;

const Body2NoMargin = styled(Body2)`
  margin-bottom: 0;
`;

const FlexWrapper = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.half};
`;

const DataLabel = styled(Body2Bold)`
  margin-bottom: ${spacing.half};
`;

const readableDateTime = (date: Date) =>
  localizeDateTime(date, {
    dateStyle: DateFormat.Full,
    timeStyle: TimeFormat.Locale,
    showTime: true,
  });

export const NonEditableDetails = ({ member }: { member: Member }) => {
  const { isMfaAvailable } = useOrganizationMembersQueryContext();
  const { createdAt, updatedAt, lastLoginAt, tfa } = member;

  return (
    <Wrapper>
      <div>
        <DataLabel>Created</DataLabel>
        <Body2>{readableDateTime(new Date(createdAt))}</Body2>
      </div>
      <div>
        <DataLabel>Updated</DataLabel>
        <Body2>{readableDateTime(new Date(updatedAt))}</Body2>
      </div>
      <div>
        <DataLabel>Last signed in</DataLabel>
        <Body2>{lastLoginAt ? readableDateTime(new Date(lastLoginAt)) : 'Never'}</Body2>
      </div>
      {isMfaAvailable && (
        <div>
          <DataLabel>Multi-factor authentication</DataLabel>
          {tfa ? (
            <FlexWrapper>
              <Body2NoMargin>Enabled</Body2NoMargin>
              <PositiveFill color={colors.green100} />
            </FlexWrapper>
          ) : (
            <FlexWrapper>
              <Body2NoMargin>Not enabled</Body2NoMargin>
              <NegativeFillDiamond color={colors.iconSubtle} />
            </FlexWrapper>
          )}
        </div>
      )}
    </Wrapper>
  );
};
